var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.576281 23.4228C0.718463 23.565 0.904281 23.6359 1.09046 23.6359C1.27664 23.6359 1.46283 23.565 1.60464 23.4228L11.9996 13.0279L22.3945 23.4228C22.5366 23.565 22.7225 23.6359 22.9086 23.6359C23.0948 23.6359 23.281 23.565 23.4228 23.4228C23.7068 23.1388 23.7068 22.6785 23.4228 22.3945L13.0279 11.9996L23.4228 1.60464C23.7068 1.32064 23.7068 0.860281 23.4228 0.576281C23.1388 0.292281 22.6785 0.292281 22.3945 0.576281L11.9996 10.9712L1.60464 0.576281C1.32064 0.292281 0.860281 0.292281 0.576281 0.576281C0.292281 0.860281 0.292281 1.32064 0.576281 1.60464L10.9712 11.9996L0.576281 22.3945C0.292281 22.6785 0.292281 23.1388 0.576281 23.4228Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.3d755110c00c6a30e7ce723bf8e8785a.svg";
export { ForwardRef as ReactComponent };